<template>
  <div class="mb-8">
    <PopupLinkPartner v-if="canSendInvite" />

    <div class="no-bids d-flex align-center justify-center" style="max-width: 960px; max-height: 386px">
      <div class="text-center">
        <v-img class="mb-6 mx-auto" src="@/assets/img/megaphone.png" width="62px" height="70px"></v-img>
        <h3 class="font font--h3 mb-2">В вашей команде пока нет партнёров</h3>
        <p class="font font--p-sm mb-6">
          {{
            `Приглашайте партнеров и получайте ${(isFL && "1500") ||
              (isUL && "2000")} рублей за нового активного партнера и далее до ${(isFL && "400") ||
              (isUL && "500")} рублей за каждого клиента, привлеченного вашими партнерами`
          }}
        </p>
        <v-row style="align-items: baseline" dense>
          <v-col cols="12" sm="5" class="font--color_light">Пригласить по ссылке:</v-col>
          <v-col cols="12" sm="7">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  single-line
                  hide-details
                  v-model="reflink"
                  dense
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  height="44"
                  width="357"
                  @click="copy(reflink)"
                  @mouseout="tooltipText = 'Кликните, чтобы скопировать ссылку'"
                ></v-text-field>
              </template>
              <span>{{ tooltipText }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import PopupLinkPartner from "./PopupLinkPartner";

export default {
  data() {
    return {
      tooltipText: "Кликните, чтобы скопировать ссылку",
    };
  },
  components: {
    PopupLinkPartner
  },
  methods: {
    copy(link) {
      if (navigator.clipboard != undefined) {
        //Chrome
        navigator.clipboard.writeText(link).then(
          function() {},
          function(err) {
            console.error("Не удолось скопировать ссылку ", err);
          }
        );
      } else if (window.clipboardData) {
        // Internet Explorer
        window.clipboardData.setData("Text", link);
      }
      this.tooltipText = "Скопировано";
    },
  },
  computed: {
    ...mapState("team", ["clid"]),
    ...mapGetters("profile", ["isUL", "isFL","canSendInvite"]),
    reflink() {
      return `${window.location.origin}/account/register?clid=${this.clid}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.v-tooltip__content {
  background: #464c59;
}
.conteiner {
  padding-top: 72px;
  padding-bottom: 72px;
}
@media (max-width: 600px) {
  .conteiner {
    padding: 0px 16px 0px 16px;
  }
}
</style>
